import { Divider } from "antd"
import AppItem from "./AppItem"

const AppCategory = ({ title, items, pendingList, onMenuClick, navigate, more, isNew }) => {
    if (items.length === 0) return null

    return (
        <div className="apps-category-section">
            <div className="apps-category-header">
                <span>
                    <Divider orientation="center">
                        {isNew ? (
                            <>
                                <span style={{ fontWeight: 'bold', color: '#eb8e03' }}>{title}</span>
                                <span className="premium-new-badge">NEW</span>
                            </>
                        ) : <span className='font-medium'>{title}</span>}
                    </Divider>
                </span>
            </div>
            <div className="apps-category-content">
                <div className="row mt-2 gy-2">
                    {items.map((item, index) => (
                        <div key={index} className="col-3 col-md-3 col-lg-3">
                            <div className="group-menu">
                                <div className="row">
                                    <div className="col d-flex justify-content-center">
                                        <AppItem item={item} pendingList={pendingList} onMenuClick={onMenuClick} navigate={navigate} more={more} />
                                    </div>
                                </div>
                                <div className="row mt-2 gy-2">
                                    <div className="col">
                                        <div className="title-item-menu">{item.nickname}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default AppCategory
